import { render, staticRenderFns } from "./insights.vue?vue&type=template&id=6a7e69d6&scoped=true&"
import script from "./insights.vue?vue&type=script&lang=js&"
export * from "./insights.vue?vue&type=script&lang=js&"
import style1 from "./insights.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7e69d6",
  null
  
)

export default component.exports